// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import userApi from '~/apis/user';
import {
  CHANGE_PASSWORD_USER,
  CREATE_USER,
  DELETE_USER,
  GET_DETAIL_USER,
  GET_LIST_USER,
  GET_USER_PROFILE,
  UPDATE_USER,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';
import { IBodyChangePassword, IQueryParamUser } from '~/utils/interface/user';

export const getListUser = createAsyncThunk(GET_LIST_USER, async (params: IQueryParamUser, { rejectWithValue }) => {
  try {
    const resp = await userApi.getListUser(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailUser = createAsyncThunk(GET_DETAIL_USER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await userApi.getDetailUser(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteUser = createAsyncThunk(DELETE_USER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await userApi.deleteUser(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createUser = createAsyncThunk(CREATE_USER, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await userApi.createUser(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateUser = createAsyncThunk(UPDATE_USER, async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
  try {
    const resp = await userApi.updateUser(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const changePasswordUser = createAsyncThunk(
  CHANGE_PASSWORD_USER,
  async (params: IBodyChangePassword, { rejectWithValue }) => {
    try {
      const resp = await userApi.changePasswordUser(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfile = createAsyncThunk(GET_USER_PROFILE, async (_, { rejectWithValue }) => {
  try {
    const resp = await userApi.getProfile();
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
